import React from 'react'
import { Link } from 'react-router-dom'

function WhoWeAre() {
  return (
    <section className="ttm-row about-section clearfix">
    <div className="container">
      <div className="row">
        <div className="col-lg-5 col-md-6 col-sm-8">
          <div className="ttm_single_image-wrapper">
            <img className="img-fluid auto_size" width={475} height={624} src="images/single-img-07.jpg" alt="single-07" />
          </div>
        </div>
        <div className="col-lg-7 col-md-12 col-xs-12">
          <div className="padding_left30 padding_top20 res-991-padding_left0 res-991-padding_top40">
            {/* section title */}
            <div className="section-title">
              <div className="title-header">
                <h3>WHO WE ARE</h3>
                <h2 className="title">The Ultimate Textile Brand in the <b>Market</b></h2>
              </div>
              <div className="title-desc">
                <p>NASK International, is a leading textile manufacturer in Pakistan, renowned for producing stylish and modern interpretations of natural and organic fabrics.</p>
              </div>
            </div>
            <div>
              <ul className="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor ttm-textcolor-darkgrey without-border">
                <li><i className="ti ti-check" /><span className="ttm-list-li-content">Cut-to-Pack Solutions – Streamlined processing from raw materials to final packaging.</span></li>
                <li><i className="ti ti-check" /><span className="ttm-list-li-content">Efficient Shipment Handling – Ensuring timely and secure delivery worldwide.</span></li>
                <li><i className="ti ti-check" /><span className="ttm-list-li-content">Quality Control Services – Rigorous inspections to maintain top-tier standards.</span></li>
                <li><i className="ti ti-check" /><span className="ttm-list-li-content">Comprehensive Audits – Detailed evaluations to optimize performance and compliance.</span></li>
                <li><i className="ti ti-check" /><span className="ttm-list-li-content">Export &amp; Import Documentation – Seamless paperwork management for hassle-free global trade.</span></li>
              </ul>
            </div>
            <div className="d-inline-block margin_top15">
              <Link className="ttm-btn ttm-btn-size-md ttm-btn-shape-square ttm-btn-style-border ttm-btn-color-dark margin_top15" to="/contact-us">contact us</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  )
}

export default WhoWeAre